// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import endpoints from "../../../endpoint";
// import SchoolIcon from "@mui/icons-material/School";

// const AdminDashboardPage = () => {
//   const [data, setData] = useState();

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(
//           endpoints.serverBaseUrl + "api/admin/dashboard",
//           {
//             withCredentials: true,
//             headers: {
//               Authorization: `Bearer ${sessionStorage.getItem("token")}`,
//             },
//           }
//         );

//         setData(response?.data?.data);
//         console.log(response);
//       } catch (error) {
//         console.log(error);
//       }
//     };
//     fetchData();
//   }, []);

//   return (
//     <div className="container mx-auto">
//       {/* Top Cards */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
//         {[
//           {
//             title: "Total Student",
//             value: data?.totalStudents,
//             icon: <i className="fas fa-users text-4xl text-blue-500"></i>,
//           },
//           {
//             title: "Total Revenue",
//             value: data?.totalRevenue,
//             icon: (
//               <i className="fas fa-dollar-sign text-4xl text-green-500"></i>
//             ),
//           },
//           {
//             title: "Total Courses",
//             value: data?.totalCourses,
//             icon: <i className="fas fa-book text-4xl text-yellow-500"></i>,
//           },
//           {
//             title: "Total Teacher",
//             value: data?.totalInstructors,
//             icon: <SchoolIcon />,
//           },
//         ].map((item) => (
//           <div
//             className="bg-white p-4 rounded-lg shadow-md flex items-center justify-between"
//             key={item.title}
//           >
//             <div>
//               <h3 className="text-lg font-semibold">{item.title}</h3>
//               <p className="text-2xl font-bold">{item.value}</p>
//             </div>
//             <div>{item.icon}</div>
//           </div>
//         ))}
//       </div>

//       {/* Pie Chart */}
//     </div>
//   );
// };

// export default AdminDashboardPage;

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import endpoints from "../../../endpoint";
// import {
//   Grid,
//   Card,
//   Typography,
//   Box,
//   Avatar,
//   CardContent,
// } from "@mui/material";
// import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
// import PeopleIcon from "@mui/icons-material/People";
// import MenuBookIcon from "@mui/icons-material/MenuBook";
// import SchoolIcon from "@mui/icons-material/School";

// const AdminDashboardPage = () => {
//   const [data, setData] = useState();

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(
//           endpoints.serverBaseUrl + "api/admin/dashboard",
//           {
//             withCredentials: true,
//             headers: {
//               Authorization: `Bearer ${sessionStorage.getItem("token")}`,
//             },
//           }
//         );
//         setData(response?.data?.data);
//       } catch (error) {
//         console.log(error);
//       }
//     };
//     fetchData();
//   }, []);

//   const cardData = [
//     {
//       title: "Total Revenue",
//       value: `₹${data?.totalRevenue || 0}`,
//       icon: <CurrencyRupeeIcon fontSize="large" />,
//       bgColor: "#d1f5e0", // greenish
//       barColor: "#37c978",
//     },
//     {
//       title: "Total Enrolled Students",
//       value: data?.totalStudents || 0,
//       icon: <PeopleIcon fontSize="large" />,
//       bgColor: "#fdd4e3", // pinkish
//       barColor: "#e91e63",
//     },
//     {
//       title: "Total Teachers",
//       value: data?.totalInstructors || 0,
//       icon: <SchoolIcon fontSize="large" />,
//       bgColor: "#ffecb3", // light yellow
//       barColor: "#f9a825",
//     },
//     {
//       title: "Total Courses",
//       value: data?.totalCourses || 0,
//       icon: <MenuBookIcon fontSize="large" />,
//       bgColor: "#bbdefb", // light blue
//       barColor: "#1e88e5",
//     },
//   ];

//   return (
//     <Box>
//       <Grid container spacing={3}>
//         {cardData.map((card, index) => (
//           <Grid item xs={12} sm={6} md={3} key={index}>
//             <Card
//               sx={{
//                 backgroundColor: card.bgColor,
//                 borderRadius: 3,
//                 boxShadow: 6,
//                 position: "relative",
//                 overflow: "hidden",
//               }}
//             >
//               <CardContent
//                 sx={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   height: 100,
//                 }}
//               >
//                 <Box>
//                   <Typography variant="subtitle2" color="textSecondary">
//                     {card.title}
//                   </Typography>
//                   <Typography variant="h5" fontWeight="bold">
//                     {card.value}
//                   </Typography>
//                 </Box>
//                 <Avatar
//                   sx={{
//                     bgcolor: "#fff",
//                     color: card.barColor,
//                     width: 48,
//                     height: 48,
//                     boxShadow: 2,
//                   }}
//                 >
//                   {card.icon}
//                 </Avatar>
//               </CardContent>

//               {/* Bottom accent strip */}
//               <Box
//                 sx={{
//                   position: "absolute",
//                   bottom: 0,
//                   left: 0,
//                   height: 6,
//                   width: "100%",
//                   bgcolor: card.barColor,
//                 }}
//               />
//             </Card>
//           </Grid>
//         ))}
//       </Grid>
//     </Box>
//   );
// };

// export default AdminDashboardPage;

import React, { useEffect, useState } from "react";
import axios from "axios";
import endpoints from "../../../endpoint";
import {
  Grid,
  Card,
  Typography,
  Box,
  Avatar,
  CardContent,
  Skeleton,
} from "@mui/material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import PeopleIcon from "@mui/icons-material/People";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import SchoolIcon from "@mui/icons-material/School";
import HandshakeIcon from "@mui/icons-material/Handshake";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import PsychologyIcon from "@mui/icons-material/Psychology";

const AdminDashboardPage = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          endpoints.serverBaseUrl + "api/admin/dashboard",
          {
            withCredentials: true,
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
        setData(response?.data?.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const cardData = [
    {
      title: "Total Revenue",
      value: `₹${data?.totalRevenue || 0}`,
      icon: <CurrencyRupeeIcon fontSize="large" />,
      bgColor: "#d1f5e0",
      barColor: "#37c978",
    },
    {
      title: "Total Enrolled Students",
      value: data?.totalStudents || 0,
      icon: <PeopleIcon fontSize="large" />,
      bgColor: "#fdd4e3",
      barColor: "#e91e63",
    },
    {
      title: "Total Teachers",
      value: data?.totalInstructors || 0,
      icon: <SchoolIcon fontSize="large" />,
      bgColor: "#ffecb3",
      barColor: "#f9a825",
    },
    {
      title: "Total Courses",
      value: data?.totalCourses || 0,
      icon: <MenuBookIcon fontSize="large" />,
      bgColor: "#bbdefb",
      barColor: "#1e88e5",
    },

    {
      title: "Total Partners",
      value: data?.totalPartners || 0,
      icon: <HandshakeIcon fontSize="large" />,
      bgColor: "#ede7f6",
      barColor: "#673ab7",
    },

    {
      title: "Withdrawal Requests",
      value: data?.totalWithdrawalRequest || 0,
      icon: <RequestQuoteIcon fontSize="large" />,
      bgColor: "#fce4ec",
      barColor: "#d81b60",
    },

    {
      title: "Total Strategies",
      value: data?.totalStrategy || 0,
      icon: <PsychologyIcon fontSize="large" />,
      bgColor: "#fff3e0",
      barColor: "#fb8c00",
    },
  ];

  return (
    <Box>
      <Grid container spacing={3} rowSpacing={6}>
        {cardData.map((card, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              sx={{
                backgroundColor: card.bgColor,
                borderRadius: 3,
                boxShadow: 6,
                position: "relative",
                overflow: "hidden",
              }}
            >
              <CardContent
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  height: 100,
                }}
              >
                <Box>
                  {loading ? (
                    <>
                      <Skeleton width={80} height={20} />
                      <Skeleton width={60} height={30} />
                    </>
                  ) : (
                    <>
                      <Typography variant="subtitle2" color="textSecondary">
                        {card.title}
                      </Typography>
                      <Typography variant="h5" fontWeight="bold">
                        {card.value}
                      </Typography>
                    </>
                  )}
                </Box>
                {loading ? (
                  <Skeleton
                    variant="circular"
                    width={48}
                    height={48}
                    sx={{ borderRadius: "50%" }}
                  />
                ) : (
                  <Avatar
                    sx={{
                      bgcolor: "#fff",
                      color: card.barColor,
                      width: 48,
                      height: 48,
                      boxShadow: 2,
                    }}
                  >
                    {card.icon}
                  </Avatar>
                )}
              </CardContent>

              {/* Bottom Accent Bar */}
              {!loading && (
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    height: 6,
                    width: "100%",
                    bgcolor: card.barColor,
                  }}
                />
              )}
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AdminDashboardPage;
